import { render, staticRenderFns } from "./ComponentsEdit.vue?vue&type=template&id=7b7f1490&scoped=true&"
import script from "./ComponentsEdit.vue?vue&type=script&lang=js&"
export * from "./ComponentsEdit.vue?vue&type=script&lang=js&"
import style0 from "./ComponentsEdit.vue?vue&type=style&index=0&id=7b7f1490&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7f1490",
  null
  
)

export default component.exports